// import React from 'react'
import Navbar from '../Components/Navbar';
// import { Link } from 'react-router-dom';
// import { BrowserRouter } from "react-router-dom"
// import Home from './Home';
import Footer from '../Components/Footer'
import Aboutpage from './About/Aboutpage';


const About = () => {
  return (
    <div>


      <Navbar />

      

      <Aboutpage />
      <Footer />
   </div>
  )
}

export default About